/* eslint-disable react/prop-types */
import { Box, Grid, Typography } from "@mui/material";
import DatepickerField from "components/DatepickerField";
import FormField from "components/FormField";
import React from "react";
import confirmDatePlugin from "flatpickr/dist/plugins/confirmDate/confirmDate";

export default function Footer({ formData }) {
  const { formField, values, errors, touched } = formData;
  const { signer, timeSign } = formField;

  return (
    <Box mt={3}>
      {/* <Box mb={4}>
        <Typography variant="h5">NHÂN VIÊN ĐẠI LÝ THUẾ</Typography>
      </Box> */}
      <Grid container spacing={3}>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            label={signer.label}
            name={signer.name}
            value={values.signer}
            error={errors.signer && touched.signer}
            success={values.signer?.toString().length > 0 && !errors.signer}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <DatepickerField
            label={timeSign.label}
            name={timeSign.name}
            error={errors.timeSign && touched.timeSign}
            success={values.timeSign?.toString().length > 0 && !errors.timeSign}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
